"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var ComfortKitIcon = function ComfortKitIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F5F5F5",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_187_111757)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#8D1414"
    // eslint-disable-next-line max-len
    ,
    d: "M9.265 2.603v-.537C9.265 1.368 8.698.8 8 .8s-1.266.568-1.266 1.266v.544C3.312 3.24.8 6.368.8 9.947v2.155C.8 13.71 2.08 15.2 3.78 15.2c1.649.001 2.953-1.372 2.953-2.981 0-.62-.19-1.214-.551-1.717a2.65 2.65 0 0 1-.473-1.236H3.78a.422.422 0 1 1 0-.844H5.76c.023-.097.061-.19.096-.283L4.327 6.611a.422.422 0 1 1 .596-.597l1.374 1.374c.41-.425.997-.654 1.703-.654.711 0 1.298.228 1.712.645l1.364-1.365a.422.422 0 1 1 .597.597l-1.51 1.51c.038.099.077.197.1.3h1.956a.422.422 0 1 1 0 .845h-1.913a2.65 2.65 0 0 1-.48 1.222 2.93 2.93 0 0 0-.56 1.73c0 1.598 1.288 2.982 2.947 2.982 1.703 0 2.987-1.486 2.987-3.098V9.688c0-3.491-2.553-6.487-5.935-7.085m-.843-.096c-.14-.008-.28-.02-.422-.02-.143 0-.282.014-.422.023v-.444a.422.422 0 1 1 .844 0z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_187_111757"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
var _default = ComfortKitIcon;
exports.default = _default;